import BaseModel from "./base-model";
import { set, getYear } from "date-fns";

const firstDayOfJanuary =
  getYear(new Date()) === 2025
    ? set(new Date(), {
        year: 2025,
        month: 1, // 2월
        date: 17, // 17일
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      })
    : set(new Date(), {
        month: 0, // 1월
        date: 1,
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      });

const firstDayOfJanuaryForConsignmentAgreement =
  getYear(new Date()) === 2026
    ? set(new Date(), {
        year: 2026,
        month: 4, // 5월
        date: 5, // 5일
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      })
    : set(new Date(), {
        month: 0, // 1월
        date: 1,
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      });

export default class User extends BaseModel {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  get userEtcObj() {
    try {
      return this.etc && JSON.parse(this.etc);
    } catch (e) {
      return {};
    }
  }

  get signatureImages() {
    return this.userEtcObj?.signatureImages;
  }

  // 위탁계약서 서명
  get consignmentAgreementDocument() {
    if (
      new Date(this.signatureImages?.consignmentAgreementDocumentDate) >
      new Date(firstDayOfJanuary)
    ) {
      return this.signatureImages?.consignmentAgreementDocument;
    }

    return null;
  }

  // 위탁수수료지급 계약서 서명
  get consignmentAgreement() {
    if (
      new Date(this.signatureImages?.consignmentAgreementDate) >
      new Date(firstDayOfJanuaryForConsignmentAgreement)
    ) {
      return this.signatureImages?.consignmentAgreement;
    }

    return null;
  }

  // 개인정보보안서약서 서명
  get personalInformationSecurityPledge() {
    if (
      new Date(this.signatureImages?.personalInformationSecurityPledgeDate) >
      new Date(firstDayOfJanuary)
    ) {
      return this.signatureImages?.personalInformationSecurityPledge;
    }

    return null;
  }

  // 개인정보제공 동의서 서명
  get personalInformationConsentForm() {
    if (
      new Date(this.signatureImages?.personalInformationConsentFormDate) >
      new Date(firstDayOfJanuary)
    ) {
      return this.signatureImages?.personalInformationConsentForm;
    }

    return null;
  }

  // 개인정보보호교육 수강 일시
  get enrolledPrivacyCourseAt() {
    if (
      new Date(this.userEtcObj?.enrolledPrivacyCourseAt) >
      new Date(firstDayOfJanuary)
    ) {
      return this.userEtcObj?.enrolledPrivacyCourseAt;
    }

    return null;
  }

  // 배송 차량 정보 제공
  get vehicles() {
    return this.userEtcObj?.vehicles || [];
  }

  get vehicle1() {
    return this.vehicles?.length > 0 ? this.vehicles[0] : null;
  }

  get vehicle2() {
    return this.vehicles?.length > 1 ? this.vehicles[1] : null;
  }
}
